import React from "react";
import { error } from "../res/Images";

export default function Error(){
    return(
        <div className="errorContainer">
            <img src={error} className="errorImage"/>
        </div>
    )
}